import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';

import MobileSidebarCard from './MobileSidebarCard';
import MobileMenuToggle from './MobileMenuToggle';
import SkyscannerBanner from './SkyscannerBanner';
import Disclaimer from './Disclaimer';
import PrevalenceFilters from './PrevalenceFilters';

class DiseasePrevalence extends Component {
	MobileSidebarCard = React.createRef();

	updateRoutingLocation() {
		const { location } = this.props;
		this.isTravel = location.pathname.includes('/travel');
	}

	render() {
		this.updateRoutingLocation();

		return (
			<div className="content-container" styles={{ border: '1px solid red' }}>
				<MobileSidebarCard ref={(ref) => (this.MobileSidebarCard = ref)}>
					<div className="mobile-header">
						<div className="intro">
							<div className="intro-title">
								<div>
									{window.vaxihub ? <a href="/" className="icon icon-vaccine-hub-logo hide-md" /> : null}
									<h1 className="priority-2 no-margin">
										<span className="icon icon-filter show-md" />
										<span className="show-md">Filter by disease</span>
										<span className="hide-md">{window.prevalence_tab_title}</span>
									</h1>
								</div>
							</div>
						</div>
					</div>
					<div className="mobile-scrollable">
						<div className="mobile-scrollable-content">
							<div className="sidebar-section">
								<div className="intro-prompt">
									<p>
										The diseases listed below represent travel-related vaccine-preventable diseases and malaria. Please
										note that these are not the only known disease risks prevalent in these countries.
									</p>
								</div>
							</div>

							<PrevalenceFilters />

							<div className="sidebar-section find-out-more">
								<div className="intro-prompt">
									<p>
										<a href={window.vaxiplace ? '/disease-directory' : '/diseases'}>Find out more about diseases</a>
									</p>
								</div>
							</div>

							<Disclaimer />
						</div>
					</div>
					<div className="mobile-footer">
						<button
							className="button button-grey button-block mobile-footer-btn"
							onClick={this.MobileSidebarCard.closeMobileCard}
						>
							Back to map
						</button>
					</div>
				</MobileSidebarCard>
				<MobileMenuToggle
					className="travel-toggle"
					text="Filter By Disease"
					onClick={this.MobileSidebarCard.openMobileCard}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const { countries, diseases } = state.json.data.prevalence;
	return {
		countries,
		diseases,
	};
};
// const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps)(DiseasePrevalence);
